import { getCookie } from '~/lib/saveCookie';
import { payConfig } from '~/config/_pages/pay';

export function openReferralLink(
  href: string, 
  utm_term?: string, 
  queryParams?: Record<string, string | number>
) {
  const refCode = getCookie('ref') ?? "landing";
  const campaignCode = getCookie('utm_campaign') ?? "";
  const paramsObj: Record<string, string> = {
    ...payConfig.ref.static_refs,
    utm_term: utm_term ?? "",
    utm_campaign: campaignCode,
    ref: refCode,
  };

  if (queryParams) {
    Object.entries(queryParams).forEach(([key, value]) => {
      paramsObj[key] = String(value);
    });
  }

  const params = new URLSearchParams(paramsObj);
  const finalUrl = `${href}?${params.toString()}`;
  
  window.open(finalUrl, '_blank', 'noopener,noreferrer');
}